<template>
  <v-app
    id="vjago"
    style="background: linear-gradient(to bottom, #b9b9b9 , #f5f5f5 30%);"
  >
    <v-app-bar
      v-if="!$store.state.loading && $route.name !== 'trip' && $route.name !== 'home'"
      app
      flat
      absolute
      color="transparent"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to bottom, rgba(96, 96, 96, 0.79), rgba(185, 185, 185, 0.5)"
        />
      </template>

      <v-btn
        v-if="backRoute"
        icon
        color="white"
        @click="$router.push(backRoute)"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title class="white--text pl-0">
        <span v-if="$store.state.navigation.title">
          {{ $store.state.navigation.title }}
        </span>

        <span v-else>
          vjago
        </span>
      </v-toolbar-title>

      <v-spacer />

      <v-btn
        v-if="$currentUser"
        color="white"
        text
        :to="{ name: 'trip-new' }"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Trip
      </v-btn>

      <the-user-menu />
    </v-app-bar>

    <v-content>
      <the-app-refresh-banner />

      <!-- Show app or loading screen -->
      <the-loader v-if="$store.state.loading" />

      <router-view v-else />
    </v-content>

    <v-footer
      v-if="!$store.state.loading"
      color="transparent"
    >
      <v-col
        cols="12"
        class="subtitle-2 grey--text text-center"
      >
        Vjago v{{ version }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import TheLoader from '@/components/TheLoader'
import TheUserMenu from '@/components/TheUserMenu'
import TheAppRefreshBanner from '@/components/TheAppRefreshBanner'
import { version } from '@/../package.json'

export default {
  components: {
    TheAppRefreshBanner,
    TheLoader,
    TheUserMenu
  },
  data () {
    return {
      version
    }
  },
  computed: {
    appBarProps () {
      const src = this.$store.state.navigation.image

      let props = {
        'shrink-on-scroll': !!src,
        prominent: !!src,
        flat: !src,
        absolute: !src
      }

      if (src) {
        props.src = src
      }

      return props
    },
    backRoute () {
      if (this.$route.meta && this.$route.meta.parent) {
        return { name: this.$route.meta.parent, params: this.$route.params }
      }
      return null
    }
  },
  mounted () {
    this.$store.dispatch('doFirstLoad')

    window.addEventListener('beforeinstallprompt', (e) => {})
  }
}
</script>

<style lang="scss">
.v-application .v-toolbar__title a {
  color: inherit;
  text-decoration: none;
}
</style>
